'use strict';

require('../../styles/templates/cart.scss');

var _cartLineItem = require('../components/cartLineItem');

var _cartAddon = require('../components/cartAddon');

var _responsiveImageSwap = require('../components/responsiveImageSwap');

var _productFinish = require('../components/product-finish');

var _customFrameSize = require('../components/customFrameSize');

var _extraOptions = require('../components/extraOptions');

var _addProperties = require('../components/addProperties');

// Import CSS
document.addEventListener('DOMContentLoaded', function () {
  (0, _cartLineItem.init)();
  (0, _cartAddon.init)();
  (0, _responsiveImageSwap.init)();
  (0, _customFrameSize.init)();
  (0, _productFinish.init)();
  (0, _extraOptions.init)();
  (0, _addProperties.init)();
});

//Reinit when theme section settings have been updated


// Components
$(document).on('shopify:section:load', function () {
  (0, _cartLineItem.init)();
  (0, _cartAddon.init)();
  (0, _responsiveImageSwap.init)();
  (0, _customFrameSize.init)();
  (0, _productFinish.init)();
  (0, _extraOptions.init)();
  (0, _addProperties.init)();
});